import React, { useMemo } from "react";
import { Button } from "./ui/button";

export default function BulkSubmitWarningModal({
  open,
  onClose,
  applications = [],
  onConfirm,
}) {
  const notReviewed = useMemo(
    () => applications.filter((a) => !a.reviewed),
    [applications]
  );

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[110]">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Modal */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl border border-gray-200 overflow-hidden">
          <div className="p-5 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">
              Submit without reviewing all?
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              You have{" "}
              <span className="font-semibold text-yellow-700">
                {notReviewed.length}
              </span>{" "}
              application(s) not reviewed. We recommend reviewing everything
              before submission.
            </p>
          </div>

          {/* List */}
          <div className="max-h-64 overflow-auto p-5">
            {notReviewed.length === 0 ? (
              <p className="text-sm text-gray-600">All applications reviewed.</p>
            ) : (
              <ul className="space-y-2">
                {notReviewed.map((a) => (
                  <li
                    key={a.application_id}
                    className="text-sm text-gray-800 flex items-center justify-between border border-gray-100 rounded-lg px-3 py-2"
                  >
                    <span>
                      {a.applicant_name || "Unnamed"} • ID: {a.application_id}
                    </span>
                    <span className="text-xs px-2 py-1 rounded bg-yellow-100 text-yellow-800 border border-yellow-200">
                      Not reviewed
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Actions */}
          <div className="p-5 border-t border-gray-200 flex items-center justify-end gap-2">
            <Button variant="outline" className="border-gray-300" onClick={onClose}>
              Go Back
            </Button>
            <Button className="bg-green-600 hover:bg-green-700 text-white" onClick={onConfirm}>
              Submit Anyway
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}